import React from "react";
import "./questlistitem.css";

export default function QuestListItem({ quest, isActive, onClick }) {
  return (
    <li
      className={`quest-list-item ${quest.category?.toLowerCase() || ""} ${isActive ? "active" : ""}`}
      onClick={() => onClick(quest.id)}
    >
      <div className="quest-title">{quest.title}</div>
      {quest.subtitle && <div className="quest-subtitle">{quest.subtitle}</div>}
    </li>
  );
}
